import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { reprocessingGuard } from './core/guards/reprocessing.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'intranet-log',
    pathMatch: 'full'
  },
  {
    path: 'auth/redirect',
    loadComponent: () =>
      import('./features/auth/redirect/auth-redirect').then(m => m.AuthRedirectComponent)
  },
  {
    path: 'iam/login',
    loadComponent: () =>
      import('./features/auth/callback/auth-callback').then(m => m.AuthCallbackComponent)
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/layout/layout').then(m => m.LayoutComponent),
    children: [
      {
        path: 'intranet-log',
        canDeactivate: [reprocessingGuard],
        loadComponent: () =>
          import('./features/intranet-log/intranet-log').then(m => m.IntranetLogComponent)
      },
      {
        path: 'protheus-log',
        canDeactivate: [reprocessingGuard],
        loadComponent: () =>
          import('./features/protheus-log/protheus-log').then(m => m.ProtheusLogComponent)
      }
    ]
  },
  { path: '**', redirectTo: '' }
];
